import { APP_BASE_HREF } from '@angular/common';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { provideApiGateway } from '@thiememeulenhoff/ng-api-gateway';
import { SecurityModule } from '@thiememeulenhoff/ng-security';
import {
  PageTitleStrategy,
  provideSentry,
  provideTham,
  provideUnleash,
} from '@thiememeulenhoff/ng-sdk';
import { baseHrefFactory } from '../_utils/base-href';
import { environment } from '../environments/environment';
import routes from '../app/app.routes';

const providers = [
  provideBrowserGlobalErrorListeners(),
  ...provideSentry,
  { provide: APP_BASE_HREF, useFactory: baseHrefFactory },
  { provide: TitleStrategy, useClass: PageTitleStrategy },
  provideUnleash(environment.unleash),
  provideApiGateway({
    environment: environment.auth.environment,
  }),
  provideRouter(
    routes,
    withEnabledBlockingInitialNavigation(),
    withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    }),
    withComponentInputBinding(),
    withRouterConfig({
      paramsInheritanceStrategy: 'always',
    }),
  ),
  importProvidersFrom(
    SecurityModule.forRoot({
      environment: environment.auth.environment,
      clientId: environment.auth.clientId,
      clientSecret: environment.auth.clientSecret,
      useUserCookie: environment.auth.useUserCookie,
    }),
  ),
  provideTham({
    cdnDomain: environment.tham.proxyDomain,
  }),
];

export const appConfig: ApplicationConfig = { providers };
